<template>
	<div id="slips" class="betslip shikisha">
		<div v-if="bets.length > 0" class="betslip-content">
			<div class="rounded-card">
				<bet
					v-for="(bet, keyValue) in bets"
					:bet="bet"
					:key="bet.parent_match_id"
					:keyValue="keyValue + 1"
				></bet>
			</div>
		</div>
		<div v-else class="betslip-content--empty">
			{{
				$t("betslip.shikisha-bets-empty", {
					shikishaProductName: env.shikishaProductName,
				}) | formatStringWithTags
			}}
			<br />
			<br />
			<router-link
				:to="env.shikishaProductName.replace(/\s/gi, '-').toLowerCase()"
				class="button button__secondary"
				>{{ $t("general.go-to") }} {{ env.shikishaProductName }}</router-link
			>
		</div>
		<load-betslip v-if="bets.length == 0" class="betslip__load-code" />
		<div class="betslip__details">
			<div class="betslip__details__container" v-if="bets.length > 0">
				<div class="betslip__details__left">
					<div
						class="betslip__details__row"
						v-show="$store.getters.balance > 0 && loggedIn"
					>
						<span class="betslip__details__row__label">{{
							$t("betslip.wallet-balance")
						}}</span>
						<span class="betslip__details__row__value">{{
							$store.getters.balance | currency
						}}</span>
					</div>
					<div class="betslip__details__row">
						<span class="betslip__details__row__label">
							<span style="margin-right: 5px">{{
								$t("betslip.total-odds")
							}}</span>
							<b-popup
								:rows="[
									{
										label: this.$t('general.minimum'),
										value: env.minTotalOdd,
										show: env.minTotalOdd,
									},
								]"
								:placement="'top-left'"
								:iconType="'solid'"
							/>
						</span>
						<span class="betslip__details__row__value"
							>{{ totalOdds > 1000000 ? "&#8734;" : totalOdds }}
							<br />
						</span>
					</div>

					<!-- Final Payout -->
					<div class="betslip__details__row">
						<span class="betslip__details__row__label">
							<span style="margin-right: 5px">{{
								$t("betslip.final-payout")
							}}</span>
							<b-popup
								:rows="[
									{
										label: this.$t('betslip.excise-tax'),
										value: $options.filters.currency(exciseTax || 0),
										show: env.exciseTax > 0,
									},
									{
										label: this.$t('betslip.stake'),
										value: $options.filters.currency(
											betAmount - exciseTax || 0
										),
										show: env.exciseTax > 0,
									},
									{
										label: this.$t('betslip.win'),
										value: $options.filters.currency(possibleWinnings || 0),
										show: possibleWinnings,
									},
									{
										label: this.$t('betslip.withholding-tax'),
										value: $options.filters.currency(tax || 0),
										show: env.whtTax > 0,
									},
								]"
								:placement="'top-left'"
								:iconType="'solid'"
								v-show="bets.length > 0"
							/>
						</span>
						<span class="betslip__details__row__value">
							{{ (possiblePayout || 0) | currency }}</span
						>
					</div>

					<!-- Amount -->
					<div class="betslip__details__row--amount">
						<div class="betslip__details__row">
							<div class="betslip__details__row__input__currency-wrap">
								<span class="betslip__details__row__input__currency-code"
									>{{ $t("betslip.amount") }} ({{ env.currency }})</span
								>
								<b-input
									class="betslip__details__row__value input"
									type="number"
									name="amount"
									v-model="amount"
									:disabled="placingBet"
									:min="env.minimumBetAmount"
									:step="env.maximumBetAmount"
									:max="env.maximumBetAmount"
									:placeholder="$t('betslip.enter-stake')"
									@mounted="
										$nextTick(() => {
											adjustBetslipHeight();
										})
									"
								>
								</b-input>
							</div>
						</div>
						<div
							class="betslip__details__row minmax"
							v-if="
								amount < env.minimumBetAmount || amount > env.maximumBetAmount
							"
						>
							<span
								>{{ $t("betslip.enter-amount-between") }}
								{{ env.minimumBetAmount | currency }} -
								{{ env.maximumBetAmount | currency }}</span
							>
						</div>
					</div>
				</div>
			</div>
			<div class="betslip__details__buttons" v-if="bets.length > 0">
				<button
					:amount="amount"
					:possibleWin="possibleWinnings"
					:totalOdds="totalOdds"
					:bonus="bonus"
					:points="points"
					:numberOfBets="numberOfBets"
					type="normal"
					class="button account__payments__submit betslip__details__button__place button button__primary bold bet-share-button"
					@click="placeBet"
					:disabled="
						placingBet ||
						amount < env.minimumBetAmount ||
						isNaN(amount) ||
						totalOdds < env.minTotalOdd
					"
					@mounted="
						$nextTick(() => {
							adjustBetslipHeight();
						})
					"
				>
					<loader v-if="placingBet" />
					<span v-else>{{
						totalOdds < env.minTotalOdd
							? this.$t("betslip.min-total-odds-of-minTotalOdd-required", {
									minTotalOdd: env.minTotalOdd,
								})
							: this.$t("betslip.button-place-bet")
					}}</span>
				</button>
				<share-button
					:bets="jengabetBetSlip"
					:profile-id="$store.getters.auth['user']['id']"
					:token="$store.getters.auth['token']"
					:bet-id="null"
					:product-type="'SHIKISHA'"
					:type="'full'"
					@mounted="
						$nextTick(() => {
							adjustBetslipHeight();
						})
					"
					:shareButtonText="this.$t('betslip.share')"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import Bet from "./ShikishaBetBet.vue";
import ShareButton from "../Share/ShareButton.vue";
import LoadBetslip from "../Share/LoadBetslip.vue";
import { isNull } from "lodash";
export default {
	name: "shikisha-betslip",
	components: {
		Bet,
		ShareButton,
		LoadBetslip,
	},
	props: ["keep"],
	data() {
		return {
			changedMatches: [],
			placingBet: false,
			infoOpen: false,
		};
	},
	watch: {
		amount(n, o) {
			n > 300000 ? (this.amount = o) : false;
			n < 0 ? (this.amount = 100) : false;
		},
		numberOfBets(n, o) {
			let vm = this;
			if (n == 1 && o == 0) {
				vm.$nextTick(() => {
					vm.adjustBetslipHeight();
				});
			}
			vm.$nextTick(() => {
				if (n === 0) return;
				document
					.querySelector(".betslip-content")
					.scroll({ behavior: "smooth", top: 10000 });
			});
		},
	},
	mounted() {
		let vm = this;
		if (vm.$store.getters.layout == "Desktop" && vm.bets.length > 0) {
			vm.$nextTick(() => {
				vm.adjustBetslipHeight();
			});
		}

		if (vm.$store.getters.layout == "Desktop") {
			if (vm.bets.length === 0) return;
			document
				.querySelector(".betslip-content")
				.scroll({ behavior: "smooth", top: 10000 });
		} else {
			vm.$nextTick(() => {
				if (vm.bets.length === 0) return;
				let el = document.getElementById("slips");

				el.scrollIntoView(false);
				window.scrollBy(0, 10000);
			});
		}
	},
	computed: {
		possiblePayout() {
			return Math.round((this.possibleWinnings - this.tax) * 100) / 100;
		},
		jengabetBetSlip() {
			return this.$store.state.jengabetBetSlip;
		},
		bets() {
			let betslip = this.$store.state.jengabetBetSlip;
			var grouped_bets = betslip.reduce((obj, bet) => {
				obj[bet.parent_match_id] = obj[bet.parent_match_id] || [];
				obj[bet.parent_match_id].push(bet);
				return obj;
			}, {});
			var groups = Object.keys(grouped_bets).map(function (key) {
				return { parent_match_id: key, bet: grouped_bets[key] };
			});
			return groups;
		},
		matches() {
			return this.$store.state.matches;
		},

		totalOdds() {
			let oddValues = this.jengabetBetSlip.map((bet) => {
				return Number(bet.odd.odd_value);
			});

			return Math.trunc(oddValues.reduce((a, b) => a * b, 1) * 100) / 100;
		},
		betAmount() {
			return this.amount;
		},
		amount: {
			// getter
			get: function () {
				let vm = this;
				if (isNull(vm.$store.getters.stake)) {
					vm.$store.commit(
						"updateStake",
						parseFloat(vm.env.defaultStakeAmount)
					);
					return vm.env.defaultStakeAmount;
				} else {
					return vm.$store.getters.stake;
				}
			},
			// setter
			set: function (stake) {
				this.$store.commit("updateStake", parseFloat(stake));
			},
		},
		possibleWinnings() {
			if (isNaN(this.betAmount)) return 0;
			let possibleWin =
				Math.trunc(this.totalOdds * (this.betAmount - this.exciseTax) * 100) /
				100;
			return possibleWin > this.env.maximumPossibleWin
				? this.env.maximumPossibleWin
				: possibleWin;
		},
		exciseTax() {
			return (
				Math.round(
					(this.betAmount - this.betAmount / (1 + this.env.exciseTax)) * 100
				) / 100
			);
		},
		tax() {
			let maxTax = this.possibleWinnings * this.env.whtTax;
			let tax =
				Math.round(
					(this.possibleWinnings - (this.betAmount - this.exciseTax)) *
						this.env.whtTax *
						100
				) / 100;
			if (tax < 0) return 0;
			return tax > maxTax ? maxTax : tax;
		},
		finalPayout() {
			return Math.trunc((this.possibleWinnings - this.tax) * 100) / 100;
		},
		bonus() {
			// Give bonus to only those bets with odd values >= 1.6
			let validOdds = this.jengabetBetSlip
				.filter((bet) => Number(bet.odd.odd_value) >= 1.6)
				.map((bet) => bet.odd.odd_value);

			// Multiply all valid odds
			let bonusOdds = validOdds.reduce((a, b) => a * b, 1);

			// Minimum bonus ratio of 5 for 5 bets
			let minimumBonusRatio = 5;

			/* Calculated bonus ratio based on
            ratio(length - ratio) || 5
          i.e. 5 bets = bonus ratio of 5, 6 bets bonus ratio of 10
      */
			let bonusRatio =
				validOdds.length == 5
					? minimumBonusRatio
					: (validOdds.length - minimumBonusRatio) * 5;

			// Give bonus for 5+ bets with odd values that are 1.5+
			if (validOdds.length >= 5) return bonusOdds * 50 * (bonusRatio / 100);
			return 0;
		},
		points() {
			if (this.totalOdds <= 3) return 0;
			let points = this.possibleWinnings / 100;
			return Math.round(points > 50 ? 5000 : points * 100) / 100;
		},
		loggedIn() {
			return JSON.parse(window.localStorage.getItem("authenticated"));
		},
		numberOfBets() {
			return this.bets.length;
		},
	},
	methods: {
		adjustBetslipHeight() {
			if (this.$store.getters.layout !== "Desktop") return;
			var desktopOffset = parseInt(
				getComputedStyle(document.body)
					.getPropertyValue("--desktop-header-offset")
					.trim()
					.replace("px", "")
			);
			var betslipDetailsHeight = document
				.querySelector(".betslip__details")
				.getBoundingClientRect().height;
			var padding = 20;
			var bottomOffset = 300;
			var betslipContentHeight = `${
				window.innerHeight -
				(desktopOffset + betslipDetailsHeight + padding + bottomOffset)
			}px`;
			document.querySelector(".betslip-content").style.maxHeight =
				betslipContentHeight;
			document.querySelector(".betslip-content").style.height = "auto";
			document.querySelector(".betslip-content").classList.add("adjusted");
		},
		clearBetslip() {
			let betslip = this.jengabetBetSlip.map((bet) => {
				return {
					sub_type_id: bet.type,
					bet_pick: bet.odd.odd_key,
					odd_value: bet.odd.odd_value,
					special_bet_value: bet.odd.special_bet_value
						? bet.odd.special_bet_value
						: "",
					parent_match_id: bet.odd.parent_match_id,
					bet_type: 5,
					is_shared: bet.is_shared,
					share_code: bet.share_code,
				};
			});

			if (window.confirm(this.$t("betslip.clear-betslip"))) {
				this.analyticsTrack("betSlip", "clear", {
					bet_slip_count: betslip.length || null,
				});
				this.$store.commit("clearJengabetBetslip");
			}
		},
		refreshBalance() {
			if (this.env.availableFeatures.balanceWidget) {
				this.$root.$emit("update-user-balance");
			} else {
				this.$axios
					.post(`${BASE_URL}balance`, {
						token: window.localStorage.getItem("token")
							? JSON.parse(window.localStorage.getItem("token"))
							: "",
					})
					.then((response) => {
						this.$store.commit("setBalance", response.data.user.balance);
					})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		placeBet(e) {
			let vm = this;
			if (vm.placingBet) return;
			if (this.amount > vm.env.maximumBetAmount) {
				vm.$notifications.add({
					type: "warning",
					title: this.$t("betslip.bet-amount-limit"),
					message:
						this.$t("betslip.maximum-bet-amount-is") +
						" " +
						`${vm.$options.filters.currency(20000)}`,
					duration: 5000,
				});
				return;
			}

			vm.placingBet = true;

			// Check whether the user is authenticated
			if (!JSON.parse(window.localStorage.getItem("authenticated"))) {
				vm.placingBet = false;

				vm.$notifications.add({
					type: "warning",
					title: this.$t("session.authentication-required"),
					message: this.$t("session.please-login-first"),
					duration: 3000,
				});
				this.$router.push("/login");
				return;
			}

			// Check whether amount > 50
			if (vm.amount < vm.env.minimumBetAmount) {
				vm.placingBet = false;

				vm.$notifications.add({
					type: "warning",
					title: this.$t("session.authentication-required"),
					message: this.$t("betslip.min-bet", {
						amount: vm.env.minimumBetAmount,
					}),
					duration: 5000,
				});
				return;
			}

			// Map betslip to endpoint requirements
			let betslip = vm.jengabetBetSlip.map((bet) => {
				return {
					sub_type_id: bet.type,
					bet_pick: bet.odd.odd_key,
					odd_value: bet.odd.odd_value,
					special_bet_value: bet.odd.special_bet_value
						? bet.odd.special_bet_value
						: "",
					parent_match_id: bet.odd.parent_match_id,
					bet_type: 5,
					is_shared: bet.is_shared,
					share_code: bet.share_code,
				};
			});

			// Build payload
			let payload = {
				profile_id: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				stake: this.amount.toString(),
				total_odd: this.totalOdds.toString(),
				src: "MOBILE_WEB",
				betslip: betslip,
				token: window.localStorage.getItem("token")
					? JSON.parse(window.localStorage.getItem("token"))
					: "",
				user_agent: localStorage.user_agent ? localStorage.user_agent : null,
				affiliate: localStorage.affiliate ? localStorage.affiliate : null,
			};

			this.analyticsTrack("shikishaBet", "attempt", {
				betslip: payload.betslip,
				num_Of_Bets: betslip.length,
				stake: vm.$options.filters.currency(vm.amount),
				user_id: payload.profile_id,
				bet_type: "shikisha",
			});
			if (
				vm.$store.getters["affiliates/affiliateTag"] &&
				vm.env.availableFeatures.affiliates
			) {
				payload.affiliate_id = vm.$store.getters["affiliates/affiliateID"];
				payload.affiliate_tag = vm.$store.getters["affiliates/affiliateTag"];
			}

			// Server request
			vm.$axios
				.post(`${BASE_URL}betbuilder/placebet`, payload)
				.then((response) => {
					vm.placingBet = false;
					this.analyticsTrack("shikishaBet", "success", {
						bet_type: "shikisha",
						betslip: payload.betslip,
						stake: vm.$options.filters.currency(vm.amount),
						total_odds: vm.totalOdds,
						user_id: payload.profile_id,
						message: response.data.message,
						value: Number(vm.amount) || 0,
						currency: window.CURRENCY,
					});

					vm.$notifications.add({


						type: "success",
						title: this.$t("betslip.bet-placement-successful"),
						message: response.data.message,
						duration: 10000,
					});
					vm.$store.commit("setBalance", response.data.user.balance);
					if (this.env.availableFeatures.balanceWidget) {
						this.$root.$emit("update-user-balance");
					}
					vm.$store.commit("SET_MYBETS_LAST_FETCH_TIME", null);

					if (!vm.keep) {
						vm.$store.commit("clearJengabetBetslip");
						vm.$router.go("-1");
					}
				})
				.catch((error) => {
					vm.placingBet = false;
					this.analyticsTrack("shikishaBet", "failed", {
						betslip: payload.betslip,
						num_Of_Bets: betslip.length,
						stake: vm.$options.filters.currency(vm.amount),
						bet_type: "shikisha",
						user_id: payload.profile_id,
						message: error.response
							? error.response.data.message
							: error.message,
					});
					if (error.response && error.response.status == 401) {
						vm.$auth.logout();
						vm.$notifications.add({
							type: "error",
							title: this.$t("session.session-expired"),
							message: this.$t("session.expired"),
							duration: 10000,
						});
						vm.$router.replace("/login");
						return;
					}
					vm.$notifications.add({
						type: "error",
						title: this.$t("betslip.bet-placement-failed"),
						message: error.response
							? error.response.data.message
							: this.$t("session.an-error-occured-please-try-again"),
						duration: 10000,
					});
				});
		},
	},
};
</script>
<style lang="scss">
.betslip.shikisha {
	.rounded-card {
		border: 0;
	}
}
.bet-share-button {
	flex: 1;
	min-width: fit-content;
}
</style>
